import React from "react";
import { useParams, Link } from "react-router-dom";
import { posts } from "../data/posts";
import { Helmet } from "react-helmet";
import NaoEncontrada from "./NaoEncontrada";

export default function Post() {

  const { slug } = useParams();

  const post = posts.find((p) => p.slug === slug);

  if (!post) {
    return <NaoEncontrada mensagem="Artigo não encontrado." />;
  }

  const url = `https://www.elaineterapia.com.br/blog/${post.slug}`;
  const imagem = "https://www.elaineterapia.com.br/og-image.jpg";

  // Dados estruturados do artigo para o Google
  const artigoLd = {
    "@context": "https://schema.org",
    "@type": "BlogPosting",
    headline: post.titulo,
    description: post.resumo,
    image: imagem,
    datePublished: post.data,
    dateModified: post.data,
    inLanguage: "pt-BR",
    mainEntityOfPage: url,
    author: {
      "@type": "Person",
      name: "Elaine Rampazzo",
      jobTitle: "Psicóloga",
      url: "https://www.elaineterapia.com.br/",
    },
  };

  return (
    <section className="py-5">

      <Helmet>
        <title>{post.titulo} | Psicóloga Elaine Rampazzo</title>
        <meta name="description" content={post.resumo} />
        <link rel="canonical" href={url} />
        <meta property="og:title" content={post.titulo} />
        <meta property="og:description" content={post.resumo} />
        <meta property="og:image" content={imagem} />
        <meta property="og:url" content={url} />
        <meta property="og:type" content="article" />
        <meta property="article:published_time" content={post.data} />
        <meta name="twitter:title" content={post.titulo} />
        <meta name="twitter:description" content={post.resumo} />
        <meta name="twitter:image" content={imagem} />
        <script type="application/ld+json">{JSON.stringify(artigoLd)}</script>
      </Helmet>

      <div className="container" style={{ maxWidth: "800px" }}>

        {/* BOTÕES DE NAVEGAÇÃO */}
        <div className="mb-4 d-flex gap-2">

          <Link to="/" className="btn btn-outline-secondary">
            <i className="bi bi-house me-2"></i>
            Início
          </Link>

          <Link to="/blog" className="btn btn-outline-success">
            <i className="bi bi-journal-text me-2"></i>
            Ver outros artigos
          </Link>

        </div>

        {/* TÍTULO */}
        <h1 className="mb-4 text-marrom-suave">
          {post.titulo}
        </h1>

        <p className="text-muted mb-4">
          {post.data}
        </p>

        {/* CONTEÚDO DO ARTIGO */}
        <div
          className="blog-content"
          dangerouslySetInnerHTML={{ __html: post.conteudo }}
        />

        {/* BLOCO FINAL DO ARTIGO */}
        <div
          className="mt-5 p-4 rounded-4"
          style={{
            background: "#f2f6f6",
            border: "1px solid #dde6e6"
          }}
        >

          <p className="mb-3">
            Se este conteúdo fez sentido para você e despertou reflexões sobre
            sua vida emocional ou profissional, saiba que você não precisa enfrentar tudo sozinho(a).
          </p>

          <p className="mb-4">
            A terapia pode ser um espaço seguro para compreender sentimentos,
            atravessar momentos difíceis, repensar a carreira e desenvolver mais equilíbrio emocional.
          </p>

          <a
            href="https://wa.me/5511962382055"
            target="_blank"
            rel="noopener noreferrer"
            className="btn-cta d-inline-flex align-items-center gap-2 px-4 py-2 mb-4"
          >
            <i className="bi bi-whatsapp"></i>
            Agendar conversa
          </a>

          <div style={{ borderTop: "1px solid #e6e6e6", paddingTop: "15px" }}>

            <div className="fw-bold text-marrom-suave">
              Elaine Rampazzo
            </div>

            <div className="text-muted">
              Psicóloga Clínica
            </div>

            <div className="text-muted">
              CRP 06/108903
            </div>

          </div>

        </div>

      </div>

    </section>
  );
}